import {
    SiBitcoin,
    SiEthereum,
    SiSolana,
    SiBinance,
    SiRipple,
    SiCardano,
    SiChainlink,
    SiPolkadot,
    SiSpacex,
  } from "react-icons/si";
  import { BsFillTriangleFill } from "react-icons/bs";
  import { PiDropSimpleFill } from "react-icons/pi";
  import { AiFillGold } from "react-icons/ai";

  export const COINS = [
    { id: "bitcoin", ticker: "BTC", name: "Bitcoin" },
    { id: "ethereum", ticker: "ETH", name: "Ethereum" },
    { id: "solana", ticker: "SOL", name: "Solana" },
    { id: "binancecoin", ticker: "BNB", name: "BNB" },
    { id: "ripple", ticker: "XRP", name: "XRP" },
    { id: "cardano", ticker: "ADA", name: "Cardano" },
    { id: "avalanche-2", ticker: "AVAX", name: "Avalanche" },
    { id: "chainlink", ticker: "LINK", name: "Chainlink" },
    { id: "polkadot", ticker: "DOT", name: "Polkadot" },
    { id: "uniswap", ticker: "UNI", name: "Uniswap" },
  ];
  
  export const ASSETS = {
    BTC: {
      name: "Bitcoin",
      icon: SiBitcoin,
      color: "#F7931A",
    },
    ETH: {
      name: "Ethereum",
      icon: SiEthereum,
      color: "#627EEA",
    },
    SOL: {
      name: "Solana",
      icon: SiSolana,
      color: "#9945FF",
    },
    BNB: {
      name: "BNB",
      icon: SiBinance,
      color: "#F3BA2F",
    },
    XRP: {
      name: "XRP",
      icon: SiRipple,
      color: "#00AAE4",
    },
    ADA: {
      name: "Cardano",
      icon: SiCardano,
      color: "#0033AD",
    },
    AVAX: {
      name: "Avalanche",
      icon: BsFillTriangleFill,
      color: "#E84142",
    },
    LINK: {
      name: "Chainlink",
      icon: SiChainlink,
      color: "#2A5ADA",
    },
    DOT: {
      name: "Polkadot",
      icon: SiPolkadot,
      color: "#E6007A",
    },
    // UNI: {
    //   name: "Uniswap",
    //   icon: SiUniswap,
    //   color: "#FF007A",
    // },
  
    // non-crypto assets
    OIL: {
      name: "Crude Oil",
      icon: PiDropSimpleFill,
      color: "#D97706",
    },
    GOLD: {
      name: "Gold",
      icon: AiFillGold,
      color: "#FBBF24",
    },
    SPACEX: {
      name: "SpaceX",
      icon: SiSpacex,
      color: "#94A3B8",
    },
  };